import { createSlice } from '@reduxjs/toolkit';
import { CreateCourseSteps } from 'src/helpers';

const stepsLength = CreateCourseSteps.length;

export const courseSlice = createSlice({
  name: 'course',
  initialState: {
    activeStep: 1,
    properties: {
      title: '',
    },
    courseID: '',
  },
  reducers: {
    onNextStep: (state) => {
      if (state.activeStep + 1 > stepsLength) return;
      state.activeStep = state.activeStep + 1;
    },
    onPreviousStep: (state) => {
      if (state.activeStep - 1 <= 0) return;
      state.activeStep = state.activeStep - 1;
    },
    onPropertiesChange: (state, payload) => {
      state.properties = payload.payload;
    },
    onIDChange: (state, payload) => {
      state.courseID = payload.payload;
    },
  },
});

export const { onNextStep, onPreviousStep, onPropertiesChange, onIDChange } = courseSlice.actions;

export default courseSlice.reducer;
